import { render, staticRenderFns } from "./FormResidentialMain.vue?vue&type=template&id=25f985f6&lang=pug&"
import script from "./FormResidentialMain.vue?vue&type=script&lang=js&"
export * from "./FormResidentialMain.vue?vue&type=script&lang=js&"
import style0 from "./FormResidentialMain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports